<template>
  <div class="bb-reject-cell"
  >
    <div class="bb-reject-cell-icons">
      <img src="@/assets/images/icon-pencil.png"
           class="bb-reject-cell__icon"
           @click.stop="setReject"
      />
    </div>
  </div>
</template>

<script>
import _ from 'lodash'
export default {
  name: 'RejectCell',
  props: ['row', 'column', 'index'],
  computed: {
    value () {
      return _.get(this.row, this.column.prop, '')
    }
  },
  methods: {
    setReject () {
      const currentElem = {row: this.row, column: this.column, index: this.index}
      this.$emit('setRejectTable', currentElem)
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../../../sass/variables";
@import "../../../../sass/mixins";
.bb-reject-cell {
  @include global-font;
  position: relative;

  &-icons {
    display: inline-flex;
    justify-content: center;
    align-items: center;
  }

  &__icon {
    width: 21px;
    height: 21px;
    cursor: pointer;

    &_cursor {
      cursor: default;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/BBTable/RejectCell/RejectCell.vue